import axios from "axios";
import { baseURL } from "./apiConstants";
import { ErrorToast } from "../widgets/AppToast";

const axiosData = {
  baseURL: baseURL,
  timeout: 12000,
  withCredentials: true,
};

var instance = axios.create(axiosData);
instance.interceptors.request.use(
  async (config) => {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let toastShown = false;

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!toastShown && error?.response?.data?.message) {
      ErrorToast("Error", error?.response?.data?.message);
      toastShown = true;
      setTimeout(() => {
        toastShown = false;
      }, 3000);
    }
    return Promise.reject(error);
  }
);

export default instance;
